/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownDeferralReason } from '../models/db_DropdownDeferralReason';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeferralReasons {
    /**
     * Get a list of deferral reasons
     * @returns db_DropdownDeferralReason OK
     * @throws ApiError
     */
    public static listDeferralReasons(): CancelablePromise<Array<db_DropdownDeferralReason>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/deferral-reasons',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
